export const NAVIGATION_COLUMN_ID = "0_1";

export const FRONTEND_ONLY_COLUMN_IDS = new Set<string>([NAVIGATION_COLUMN_ID]);

export const isFrontendOnlyColumnId = (colId: string | null | undefined): colId is string => {
  return colId != null && FRONTEND_ONLY_COLUMN_IDS.has(colId);
};
